import { ChatThinking } from '~/components/chat/chat-thinking'
import type { ToolActivity } from '~/hooks/use-chat-stream'

export interface StreamingIndicatorProps {
    /** 진행 중인 도구 활동(있으면 사람이 이해할 문구를 보여준다). */
    toolActivity?: ToolActivity | null
    className?: string
}

/** 스트리밍/도구 사용 상태를 공통 톤앤매너(ChatThinking)로 표시한다. */
export function StreamingIndicator({
    toolActivity,
    className,
}: StreamingIndicatorProps) {
    // 도구 활동이 있으면 그 문구로 고정, 없으면 공통 순환 문구.
    return (
        <ChatThinking
            phrases={toolActivity?.label ? [toolActivity.label] : undefined}
            className={className}
        />
    )
}
